import PaginationController from './PaginationController';

export default PaginationController;
